import { Grid, Box, Typography, SVGIcon, customTheme } from "src/components";
import { TRANSPORT_MODE_MAPPINGS } from "src/data";
import { useIsMobile } from 'src/hooks';

export default function TransportModeSelector({ value, onChange }) {
  const isMobile = useIsMobile();

  return (
    <>
      <Typography variant="h6" mb={1}>
        Choose Your Rig
      </Typography>
      <Grid container spacing={1} columns={{ xs: 4, sm: 4, md: 4 }}>
        {Object.entries(TRANSPORT_MODE_MAPPINGS).map(([key, { label, icon }]) => (
          <Grid size={2} key={key}>
            <Box
              onClick={() => onChange(key)}
              sx={{
                border: value === key ? `2px solid ${customTheme.palette.primary.main}` : '1px solid #D3D3D3',
                borderRadius: 2,
                p: 1.5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                height: '100%',
                textAlign: 'center',
                transition: 'border 0.2s ease',
                '&:hover': {
                  borderColor: '#888'
                }
              }}
            >
              <SVGIcon icon={icon} size={isMobile ? 80 : 80} />
              <Typography variant="body2" fontWeight={600}>
                {label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
